(() => {
  const savedTheme = localStorage.getItem("arc-theme");
  const supportedThemes = new Set(["light", "dark"]);
  const theme = supportedThemes.has(savedTheme) ? savedTheme : "light";
  const isDark = theme === "dark";
  const root = document.documentElement;

  root.dataset.arcTheme = theme;
  root.classList.toggle("dark", isDark);
  root.style.colorScheme = isDark ? "dark" : "light";
})();
